import { config } from 'config'

interface Props {
	envId?: string
}

const Workspace = ({ envId }: Props) => {
	if (config.THEIA_LOCAL_CONNECTION) {
		return (
			<iframe
				class='h-full w-full bg-black-900'
				height='100%'
				src='/workspace'
				title='workspace-frame'
				width='100%'
			/>
		)
	}

	if (!envId) {
		return <div />
	}

	return (
		<iframe
			class='h-full w-full bg-black-900'
			height='100%'
			src={`/workspace?envId=${envId}`}
			title='workspace-frame'
			width='100%'
		/>
	)
}

export { Workspace }
